import { trans } from '@codebuild/cookie-jar/libs/translation/trans';
import { arrayToClass } from '@codebuild/cookie-jar/uikit/libs/array-to-class';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { LoginComponent } from '../../components/authentication/login/login.component';
import { generateLink } from '../../libs/generate-link';
import { Subscribable } from '../../libs/subscribable';
import { HOME_PAGE, routes } from '../../routes';
import './login.screen.scss';

const logo = require('../../assets/images/selectivita-logo-symbol.svg');

export class LoginScreen extends Subscribable<any, any> {

    public render(): React.ReactNode {
        return <div className={'LoginScreen p-box'}>
            <div className="row flex-fill">
                <div className="col-xl-8 col-lg-10 col-md-14 col-24">
                    {this.renderLoginBox()}
                </div>
                <div className="col-xl-16 col-lg-14 display-lg-flex display-none p-box">
                    <img className={'ImageSlide'} src={trans('loginImage')} alt="login image"/>
                </div>
            </div>
        </div>;
    }

    public renderLoginBox() {
        const loginContainer = arrayToClass([
            ' palette--bgc-neutral-2 display-flex flex-column p-box',
            'LoginContainer'
        ]);
        return <div className={loginContainer}>
            {this.renderLoginHeadLine()}
            <LoginComponent/>
        </div>;
    }

    public renderLoginHeadLine() {
        return <div className={'row mb-7'}>
            <a href={HOME_PAGE} className={'col-sm-10 col-24 text-decoration-none mb-sm-0 mb-7'}>
                <div className={'justify-content-start align-items-center display-flex flex-row'}>
                    <img src={logo} className={'Logo'} alt="logo"/>
                    <h2 className={'mb-0 ml-7'}>Selectivita</h2>
                </div>
            </a>
            <div className={'col-sm-14 col-24 justify-content-end align-items-sm-end align-items-center display-flex flex-column'}>
                <span className={'palette--c-neutral-5'}>{trans('login.signup.title')}</span>
                <Link to={generateLink(routes.registration)} className={'fs-large palette--c-blue-2 fw-bold text-decoration-none'}>{trans('login.signup.button')}</Link>
            </div>
        </div>;
    }
}
